<template>
	<ion-button
		id="quick-create-menu-button"
		slot="end"
		class="mr-4"
		color="branding2"
	>
		<ion-text>{{ t("sidemenu.quick-create") }}</ion-text>
		<ion-icon slot="end" :icon="addOutline" />
	</ion-button>

	<ion-popover
		trigger="quick-create-menu-button"
		trigger-action="click"
		:dismiss-on-select="true"
	>
		<ion-content>
			<ion-list>
				<ion-item
					v-if="myUser?.hasPermission(PermissionKey.CreateFieldNotes)"
					button
					@click="viewGlobalModal('create-note')"
				>
					<ion-icon slot="start" :icon="chatboxOutline" />
					<ion-label>{{ t("note.note", 1) }}</ion-label>
				</ion-item>
				<ion-item
					v-if="
						myUser?.hasPermission(PermissionKey.CreateTaskRequest)
					"
					button
					@click="viewGlobalModal('task-request')"
				>
					<ion-icon slot="start" :icon="clipboardOutline" />
					<ion-label>{{ t("task.task-request", 1) }}</ion-label>
				</ion-item>
				<ion-item
					v-if="myUser?.hasPermission(PermissionKey.EditPlantings)"
					button
					@click="viewGlobalModal('batch-add-plantings')"
				>
					<ion-icon slot="start" :icon="leafOutline" />
					<ion-label>{{ t("sidemenu.add-plantings") }}</ion-label>
				</ion-item>
			</ion-list>
		</ion-content>
	</ion-popover>
</template>

<script setup lang="ts">
	import {
		IonButton,
		IonIcon,
		IonText,
		IonPopover,
		IonContent,
		IonList,
		IonItem,
		IonLabel,
	} from "@ionic/vue";
	import {
		addOutline,
		chatboxOutline,
		clipboardOutline,
		leafOutline,
	} from "ionicons/icons";
	import { PermissionKey } from "seedgreen-shared/dtos/PermissionTypeDTO";
	import { useMyUser } from "seedgreen-shared/queries/user";
	import { useModalNavigation } from "@/composables/useModalNavigation";
	import { useI18n } from "vue-i18n";

	const { t } = useI18n();
	const { myUser } = useMyUser();
	const { viewGlobalModal } = useModalNavigation();
</script>
